export const areDatesEqual = (dateA, dateB) => +dateA === +dateB;
export default (dateA, dateB) => {
  const [a, b] = [new Date(dateA), new Date(dateB)];
  if (areDatesEqual(a, b)) return 0;
  if (a > b) return 1;
  return -1;
};
